import request from "superagent";

export const GET_AUTH_URL = "user/GET_AUTH_URL";
export const GET_AUTH_URL_DATA_RECEIVED = "user/GET_AUTH_URL_DATA_RECEIVED";
export const GET_AUTH_URL_ERROR = "user/GET_AUTH_URL_ERROR";

export const GET_PRE_LOGIN_FEATURES = "featureFlags/GET_PRE_LOGIN_FEATURES";
export const GET_PRE_LOGIN_FEATURES_DATA_RECEIVED =
  "featureFlags/GET_PRE_LOGIN_FEATURES_DATA_RECEIVED";
export const GET_PRE_LOGIN_FEATURES_ERROR =
  "featureFlags/GET_PRE_LOGIN_FEATURES_ERROR";

export const GET_POST_LOGIN_FEATURES = "featureFlags/GET_POST_LOGIN_FEATURES";
export const GET_POST_LOGIN_FEATURES_DATA_RECEIVED =
  "featureFlags/GET_POST_LOGIN_FEATURES_DATA_RECEIVED";
export const GET_POST_LOGIN_FEATURES_ERROR =
  "featureFlags/GET_POST_LOGIN_FEATURES_ERROR";

export const GET_LOCALE = "localization/GET_LOCALE";
export const GET_LOCALE_DATA_RECEIVED = "localization/GET_LOCALE_DATA_RECEIVED";
export const GET_LOCALE_ERROR = "localization/GET_LOCALE_ERROR";

export const coreDataService = store => next => action => {
  // pass all actions forward by default
  //console.log(action);
  next(action);

  switch (action.type) {
    // if a action asks for a request, send that request
    case GET_PRE_LOGIN_FEATURES:
      request
        .get("/api/public/featureFlags/preLogin")
        .catch(err => {
          return next({
            type: GET_PRE_LOGIN_FEATURES_ERROR,
            err
          });
        })
        .then(res => {
          const data = res.body;

          return next({
            type: GET_PRE_LOGIN_FEATURES_DATA_RECEIVED,
            data
          });
        });
      break;
    case GET_POST_LOGIN_FEATURES:
      request
        .get("/api/featureFlags/postLogin")
        .query({ username: action.username })
        .catch(err => {
          return next({
            type: GET_POST_LOGIN_FEATURES_ERROR,
            err
          });
        })
        .then(res => {
          const data = res.body;

          return next({
            type: GET_POST_LOGIN_FEATURES_DATA_RECEIVED,
            data
          });
        });
      break;

    case GET_LOCALE:
      request
        .get(
          `locales/${action.locale
            .replace(/_/g, "-")
            .toLowerCase()}/common.json`
        )
        .catch(err => {
          return next({
            type: GET_LOCALE_ERROR,
            err
          });
        })
        .then(res => {
          const data = res.body;

          return next({
            type: GET_LOCALE_DATA_RECEIVED,
            locale: action.locale,
            data: data
          });
        });
      break;

    case GET_AUTH_URL:
      request
        .get("/api/public/getAuthUrl")
        .query({ username: action.username })
        .catch(err => {
          return next({
            type: GET_AUTH_URL_ERROR,
            err
          });
        })
        .then(res => {
          const data = res.body;

          return next({
            type: GET_AUTH_URL_DATA_RECEIVED,
            data
          });
        });
      break;

    // By default, do nothing if nothing intrests us
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./src/services/coreDataService.js